import  React, {use, useState, useEffect} from 'react';
import MenuBar from "../components/MenuBar";
import "./styles/AdminPanel.css";
import "./styles/estandar/ButtonStyles.css";

import { FaUsers } from "react-icons/fa";
import { FaPlusCircle } from "react-icons/fa";

import CreateUserForm from '../components/CreateUserForm';
import ListUsers from '../components/ListUsers';
import Cookies from 'js-cookie';
import { useNavigate, useParams } from "react-router-dom";
import EditUserForm from '../components/EditUserForm';

//RpPrA
const EditarUsuario = () =>{

    const {id_usuario} = useParams();

    const [panelOption, setPanelOption] = useState("listaUsuarios");
    const [titulo, setTitulo] = useState("Panel administración : Editar usuario");

/*Funcion para validar el tipo de session*/

    const navigate = useNavigate();
    
    const [admin, setAdmin] = useState(false);
    const validarSesion = () =>{

        if(Cookies.get("turid")){
            const turid = Cookies.get("turid");
            if(turid === "rid1"){
                setAdmin(true);
            }else{
                navigate("/");
                Cookies.remove("usr");
                Cookies.remove("turid");
            }
        }else{
            navigate("/");
            Cookies.remove("usr");
        }
    }
    useEffect(() =>{
        validarSesion();
    },[])



    const handlePanelUsuarios = () =>{
        setTitulo("Panel administración : Usuarios");
        navigate("/adminPanel");
    }




    return(
        <div>
            <MenuBar pagina="adminPanel" sesion={admin}/>
            <div className="bodyAdminPanel">
                <h1 className="AdminPanelTitle">{titulo}</h1>
                <div className="AdminPanelCl">
                    <div className="optionsAdminPanel">
                        <button className="buttonStandart" onClick={handlePanelUsuarios}><FaUsers />Usuarios</button>
                    </div>
                    <div className="contentAdminPanel">
                        <EditUserForm/>
                        
                    </div>
                </div>
            </div>
            
            </div>
    );
}

export default EditarUsuario;